import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const NonDatasourceFieldIconFragmentGql: DocumentNode = gql`
fragment NonDatasourceFieldIconFragment on Field {
  __typename
  ... on DataField {
    dataCategory
    dataType
  }
  ... on AnalyticsField {
    semanticRole
  }
  ... on BinField {
    binField: id
  }
  ... on CalculatedField {
    calculatedField: id
  }
  ... on ColumnField {
    columnField: id
  }
  ... on CombinedField {
    combinedField: id
  }
  ... on CombinedSetField {
    combinedSetField: id
  }
  ... on GroupField {
    groupField: id
    fieldsReferencedByGroup: fields {
      ... on AnalyticsField {
        semanticRole
      }
    }
  }
  ... on HierarchyField {
    hierarchyField: id
  }
  ... on SetField {
    setField: id
  }
}
`;
